import DocumentPage from "./page"
import Document from "../document"

export default class DocumentPages {

    public document : Document
    private _items  : DocumentPage[]

    constructor(pages: any, document: Document) {

        this.document = document

        this._items = [];
        _.map(pages, page=>{
            this.addPage(page)
        });
    }

    getItems = () => this._items
    get models() {return this._items}
    get length() {return this._items.length}

    generateNewPageTitle = () => {
        return 'Page '+(this.length +1)
    }

    addPage = (data: any) => {

        let newPage

        if (data.constructor.name === DocumentPage.constructor.name) {
            newPage = data
        } else {
            if (!data.title) data.title = this.generateNewPageTitle()
            newPage = new DocumentPage(data, this.document)
        }

        this._items.push(newPage);
        return newPage;
    }

    removePage = (pageId: ID) => {
        _.remove(this._items, item=>item.id === pageId)
    }

    getPage = (pageId: ID) => {
        return _.find(this._items, item=>item.id === pageId)
    }

    getPreviousPage = (pageId: ID) => {
        let res
        const pageIndex = _.findIndex(this._items, item=>item.id === pageId)
        if (pageIndex > 0) {
            res =  this._items[pageIndex - 1]
        } else if (pageIndex === 0) {
            res =  this._items[pageIndex + 1]
        } else {
            res = this.getFirstPage()
        }
        return res
    }

    getFirstPage = () => {
        let firstPage = _.first(this._items)

        if (!firstPage) {

            firstPage = new DocumentPage({
                title: this.generateNewPageTitle()
            }, this.document)
            this.addPage(firstPage)

        }

        return firstPage
    };

    reorder = (orderedPageIds: ID[]) => {this._items = _.orderBy(this._items, item=>_.indexOf(orderedPageIds, item.id));}

    toJSON = () => _.map(this._items, item=>item.toJSON())
}